import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import actionFe from 'utils/mw/actionFe.util';
import tracked from 'utils/redux/tracked.util';

// NOTE: the first parameter is the name of the action
// NOTE: the second is just to repeat the same, if not function, it will just use the same data
// NOTE: the third parameter adds the meta field with tracking sub-field
const fePickCurrentTime = actionFe('fePickCurrentTime', alwaysSame, tracked);

export default fePickCurrentTime;
